import { useState } from "react";
import { useReveal } from "../../lib/useReveal";
import { toast } from "sonner";

const FORMSUBMIT_ENDPOINT =
    "https://formsubmit.co/ajax/contato@fluxonasvendas.com.br";

const empty = {
    nome: "",
    empresa: "",
    email: "",
    telefone: "",
    faturamento: "",
    segmento: "",
    mensagem: "",
};

const faturamentos = [
    "Até R$ 100k/mês",
    "R$ 100k – R$ 500k/mês",
    "R$ 500k – R$ 1M/mês",
    "R$ 1M – R$ 5M/mês",
    "Acima de R$ 5M/mês",
];

export default function CTAFinal() {
    const ref = useReveal();
    const [form, setForm] = useState(empty);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);

    const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

    const onSubmit = async (e) => {
        e.preventDefault();
        if (
            !form.nome ||
            !form.empresa ||
            !form.email ||
            !form.telefone ||
            !form.faturamento ||
            !form.segmento
        ) {
            toast.error("Complete os campos obrigatórios para submeter à triagem.");
            return;
        }
        setLoading(true);
        try {
            const payload = {
                _captcha: "false",
                _subject: "Nova candidatura - Fluxo nas Vendas",
                Responsavel: form.nome,
                Operacao: form.empresa,
                Email: form.email,
                Telefone: form.telefone,
                Faturamento: form.faturamento,
                Segmento: form.segmento,
                Contexto: form.mensagem,
            };
            const res = await fetch(FORMSUBMIT_ENDPOINT, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
                body: JSON.stringify(payload),
            });
            const data = await res.json().catch(() => ({}));
            if (!res.ok || data.success === "false") {
                throw new Error(data.message || "submit_failed");
            }
            setSuccess(true);
            setForm(empty);
            toast.success("Candidatura registrada. Sua operação entrou em análise.");
        } catch (err) {
            toast.error(
                "Não foi possível submeter sua candidatura. Tente novamente."
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <section
            data-testid="cta-final"
            id="cta-final"
            className="relative py-28 lg:py-40 border-t border-white/5 bg-[#070707] overflow-hidden"
        >
            <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#d4af37]/40 to-transparent" />
            <div className="grain-overlay" />

            <div ref={ref} className="reveal max-w-6xl mx-auto px-6 lg:px-10 relative">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-20">
                    <div className="lg:col-span-5">
                        <div className="flex items-center gap-4 mb-8">
                            <span className="h-px w-10 bg-[#d4af37]" />
                            <span className="tag-fluxo">Triagem · Acesso Restrito</span>
                        </div>
                        <h2 className="font-['Outfit'] font-bold uppercase tracking-[-0.02em] text-4xl md:text-5xl lg:text-[56px] leading-[0.95]">
                            <span className="text-white">Apresente sua</span>
                            <br />
                            <span className="text-gold-gradient">operação.</span>
                        </h2>
                        <p className="mt-8 text-white/55 leading-relaxed text-base md:text-lg">
                            Cada candidatura é submetida a comitê interno de viabilidade
                            estratégica. O envio deste formulário não representa
                            aprovação — apenas o início da análise.
                        </p>
                        <div className="mt-12 space-y-5 text-sm">
                            {[
                                "Triagem confidencial conduzida por sócios",
                                "Avaliação sem custo e sem compromisso",
                                "Retorno em até 5 dias úteis, somente em caso de fit",
                            ].map((t, i) => (
                                <div key={i} className="flex items-center gap-3">
                                    <span className="w-1.5 h-1.5 bg-[#d4af37]" />
                                    <span className="text-white/70 font-['Outfit'] tracking-wide">
                                        {t}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="lg:col-span-7">
                        {success ? (
                            <div
                                data-testid="form-success"
                                className="border border-[#d4af37]/30 bg-[#0d0d0d] p-10 lg:p-14 text-center"
                            >
                                <div className="text-[#d4af37] text-sm tracking-[0.32em] uppercase font-['Outfit'] mb-4">
                                    Candidatura Registrada
                                </div>
                                <h3 className="text-white font-['Outfit'] font-bold uppercase text-3xl md:text-4xl tracking-tight leading-tight mb-6">
                                    Sua operação entrou em triagem.
                                </h3>
                                <p className="text-white/55 max-w-md mx-auto leading-relaxed">
                                    O comitê irá analisar o perfil submetido sob sigilo
                                    estratégico. Havendo aderência ao nosso modelo
                                    operacional, o contato será feito em até 5 dias úteis.
                                </p>
                                <button
                                    data-testid="form-reset"
                                    onClick={() => setSuccess(false)}
                                    className="mt-10 text-[#d4af37] text-[12px] uppercase tracking-[0.28em] hover:text-[#f5d76e] transition-colors font-['Outfit']"
                                >
                                    ← Submeter nova candidatura
                                </button>
                            </div>
                        ) : (
                            <form
                                onSubmit={onSubmit}
                                data-testid="lead-form"
                                className="border border-white/10 bg-[#0a0a0a] p-8 lg:p-12 space-y-7"
                            >
                                <div className="flex items-center justify-between pb-2 border-b border-white/5">
                                    <span className="tag-fluxo text-white/40">
                                        Ficha de Submissão
                                    </span>
                                    <span className="text-[11px] tracking-[0.32em] uppercase text-white/30 font-['Outfit']">
                                        Confidencial
                                    </span>
                                </div>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-7">
                                    <div>
                                        <div className="label-fluxo mb-2">
                                            01 · Responsável
                                        </div>
                                        <input
                                            data-testid="form-nome"
                                            className="fluxo-input"
                                            value={form.nome}
                                            onChange={update("nome")}
                                            placeholder="Nome completo do decisor"
                                        />
                                    </div>
                                    <div>
                                        <div className="label-fluxo mb-2">
                                            02 · Operação
                                        </div>
                                        <input
                                            data-testid="form-empresa"
                                            className="fluxo-input"
                                            value={form.empresa}
                                            onChange={update("empresa")}
                                            placeholder="Razão social ou marca"
                                        />
                                    </div>
                                </div>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-7">
                                    <div>
                                        <div className="label-fluxo mb-2">
                                            03 · E-mail corporativo
                                        </div>
                                        <input
                                            data-testid="form-email"
                                            type="email"
                                            className="fluxo-input"
                                            value={form.email}
                                            onChange={update("email")}
                                            placeholder="nome@empresa.com"
                                        />
                                    </div>
                                    <div>
                                        <div className="label-fluxo mb-2">
                                            04 · Contato direto
                                        </div>
                                        <input
                                            data-testid="form-telefone"
                                            className="fluxo-input"
                                            value={form.telefone}
                                            onChange={update("telefone")}
                                            placeholder="+55 (00) 00000-0000"
                                        />
                                    </div>
                                </div>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-7">
                                    <div>
                                        <div className="label-fluxo mb-2">
                                            05 · Patamar de receita
                                        </div>
                                        <select
                                            data-testid="form-faturamento"
                                            className="fluxo-input"
                                            value={form.faturamento}
                                            onChange={update("faturamento")}
                                        >
                                            <option value="">Selecione o intervalo</option>
                                            {faturamentos.map((f) => (
                                                <option key={f} value={f}>
                                                    {f}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div>
                                        <div className="label-fluxo mb-2">
                                            06 · Mercado de atuação
                                        </div>
                                        <input
                                            data-testid="form-segmento"
                                            className="fluxo-input"
                                            value={form.segmento}
                                            onChange={update("segmento")}
                                            placeholder="Setor principal da operação"
                                        />
                                    </div>
                                </div>
                                <div>
                                    <div className="label-fluxo mb-2">
                                        07 · Contexto estratégico
                                        <span className="ml-2 text-white/25 normal-case tracking-normal text-[10px]">
                                            (opcional)
                                        </span>
                                    </div>
                                    <textarea
                                        data-testid="form-mensagem"
                                        rows={3}
                                        className="fluxo-input resize-none"
                                        value={form.mensagem}
                                        onChange={update("mensagem")}
                                        placeholder="Estágio atual e objetivo estratégico em linhas gerais"
                                    />
                                </div>
                                <div className="pt-6 border-t border-white/5">
                                    <button
                                        data-testid="form-submit"
                                        type="submit"
                                        disabled={loading}
                                        className="btn-gold w-full md:w-auto px-10 py-4 text-[12px] uppercase tracking-[0.28em] font-bold font-['Outfit'] disabled:opacity-60 disabled:cursor-not-allowed"
                                    >
                                        <span>
                                            {loading
                                                ? "Submetendo…"
                                                : "Submeter para Triagem →"}
                                        </span>
                                    </button>
                                    <p className="mt-5 text-white/40 text-xs leading-relaxed max-w-md">
                                        Ao submeter, você autoriza a análise confidencial
                                        de elegibilidade pela FLUXO NAS VENDAS.
                                        Informações tratadas sob sigilo estratégico.
                                    </p>
                                </div>
                            </form>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
}
